// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.properties.photos.RentalManagerUserPropertyPhotoWebApiHandler

import type { UseMutationOptions } from '@zg-rentals/react-query5';
import { useMutation } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import {
  RentalManagerUserPropertyPhotoWebApiHandler_caption,
  RentalManagerUserPropertyPhotoWebApiHandler_delete,
  RentalManagerUserPropertyPhotoWebApiHandler_rank,
  RentalManagerUserPropertyPhotoWebApiHandler_upload,
} from '@zg-rentals/ts-rental-manager-api-client';

import type {
  ListingAlias,
  UpdatePropertyPhotoRankRequestWebDto,
  UserPropertyFloorPlanPhotoUploadRequestWebDto,
  UserPropertyPhotoUploadResponseWebDto,
} from '@zg-rentals/ts-rental-manager-api-client';

interface CaptionParams {
  caption?: string;
  photoId: string;
}
interface DeleteParams {
  photoId: string;
}
interface RankParams {
  listingAlias: ListingAlias;
}
interface UploadParams {
  listingAlias: ListingAlias;
  sourceUrl?: string;
}

export interface RentalManagerUserPropertyPhotoWebApiHandler_caption_Args {
  getParams: CaptionParams;
}

export type RentalManagerUserPropertyPhotoWebApiHandler_caption_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyPhotoWebApiHandler_caption_Args
>;

/**
 * Update a photo caption
 */
export const useRentalManagerUserPropertyPhotoWebApiHandler_caption = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyPhotoWebApiHandler_caption_Options, 'mutationFn'> & { httpClient?: Client } = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyPhotoWebApiHandler_caption_Args) =>
      RentalManagerUserPropertyPhotoWebApiHandler_caption(args.getParams, httpClient),
  });
};

export interface RentalManagerUserPropertyPhotoWebApiHandler_delete_Args {
  getParams: DeleteParams;
}

export type RentalManagerUserPropertyPhotoWebApiHandler_delete_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyPhotoWebApiHandler_delete_Args
>;

/**
 * Delete a property photo
 */
export const useRentalManagerUserPropertyPhotoWebApiHandler_delete = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyPhotoWebApiHandler_delete_Options, 'mutationFn'> & { httpClient?: Client } = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyPhotoWebApiHandler_delete_Args) =>
      RentalManagerUserPropertyPhotoWebApiHandler_delete(args.getParams, httpClient),
  });
};

export interface RentalManagerUserPropertyPhotoWebApiHandler_rank_Args {
  getParams: RankParams;
  postData: UpdatePropertyPhotoRankRequestWebDto;
}

export type RentalManagerUserPropertyPhotoWebApiHandler_rank_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyPhotoWebApiHandler_rank_Args
>;

/**
 * Update the rank of photos
 */
export const useRentalManagerUserPropertyPhotoWebApiHandler_rank = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyPhotoWebApiHandler_rank_Options, 'mutationFn'> & { httpClient?: Client } = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyPhotoWebApiHandler_rank_Args) =>
      RentalManagerUserPropertyPhotoWebApiHandler_rank(args.getParams, args.postData, httpClient),
  });
};

export interface RentalManagerUserPropertyPhotoWebApiHandler_upload_Args {
  getParams: UploadParams;
  postData: UserPropertyFloorPlanPhotoUploadRequestWebDto;
}

export type RentalManagerUserPropertyPhotoWebApiHandler_upload_Options = UseMutationOptions<
  UserPropertyPhotoUploadResponseWebDto,
  unknown,
  RentalManagerUserPropertyPhotoWebApiHandler_upload_Args
>;

/**
 * Upload a property photo
 */
export const useRentalManagerUserPropertyPhotoWebApiHandler_upload = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyPhotoWebApiHandler_upload_Options, 'mutationFn'> & { httpClient?: Client } = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyPhotoWebApiHandler_upload_Args) =>
      RentalManagerUserPropertyPhotoWebApiHandler_upload(args.getParams, args.postData, httpClient),
  });
};
